import { extendReplicantConfigForAnalytics } from '@play-co/gcinstant-replicant-extensions';
import { createConfig } from '@play-co/replicant';

import { stateSchema, State } from './State';
import messages from './messages';
import actions from './actions';
import migrator from './migrator';
import chatbot from './chatbot';
import computedProperties from './computedProperties';
import scheduledActions from './scheduledActions';
import ab from './ruleset/ab';
import { encodeReplicantMessagePayload } from './payloads';
import { asyncGetters } from './asyncGetters';
import { Admin } from './admin';

const VERSION = process.env.APP_VERSION;
const appName = process.env.APP_NAME && process.env.APP_NAME.replace(/'/g, '');

const config = createConfig({
  stateSchema,
  ruleset: { abTests: ab.dynamicAB },
  messages,
  scheduledActions,
  actions,
  asyncGetters,
  migrator,
  chatbot,
  encodePlatformMessagePayload: encodeReplicantMessagePayload,
  computedProperties,
  onLoginAction: 'onLogin',
  appName,
  version: VERSION,
  adminTool: Admin.tools,
});

export default extendReplicantConfigForAnalytics(config, {
  getPlatformStorage: (state: State) => state.platformStorage,
});
